import { brand } from "../config/brands";
import React, { useEffect, useState } from "react";
import Layout from "../component/Layout";
import { getCustomers, saveNotification } from "../adapter/api";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BellAlertIcon, PaperAirplaneIcon, UserGroupIcon, UserIcon } from "@heroicons/react/24/outline";
import "./Notifications.css";

const Notifications = () => {
  const [notificationType, setNotificationType] = useState("Multiple Notification");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [customers, setCustomers] = useState([])
  const [clients, setClients] = useState([]);

  const handleNotificationChange = (e) => {
    setNotificationType(e.target.value);
    if (e.target.value === "Multiple Notification") {
      setSelectedCustomer(""); // Reset customer selection when switching back
    }
  };

  const handleSubmit =async () => {

    const myUser = JSON.parse(await AsyncStorage.getItem('myUser'))

    try{

    
    if(notificationType === "Single Notification"){
      
      const myCustomer = clients.filter(x => x.customerId == selectedCustomer)

        var body = {
            "subject": title,
            "content": content,
            "sound": "default",
            "image": "https://somedomain.com/example.jpg",
            "data": {
                "key1": "Value 1",
                "key2": "Value 2",
                "key3": "Value 3",
                "key4": "Value 4"
            }
        }
        var service = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(body)
        }
        try {
            fetch(`${brand.apiBaseUrl}/send-notification?token=` + myCustomer[0].deviceToken, service)
            .then(async res => {
              toast.success("Notification Sent Succesfully")
              setTitle("")
              setContent("")
              const response = await saveNotification(title, content,myCustomer[0].customerId)
            })
                .then(response => {
                 
            
                });
           

        }
        catch (err) {
          toast.error("Error sending notification !")
        }


    }else{

        var body = {
            "subject": title,
            "content": content,
            "sound": "default",
            "image": "https://somedomain.com/example.jpg",
            "data": {
                "key1": "Value 1",
                "key2": "Value 2",
                "key3": "Value 3",
                "key4": "Value 4"
            }
        }
        var service = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(body)
        }
        try {
            fetch(`${brand.apiBaseUrl}/send-multiple`, service).then(res => res.json())
                .then(async response => {
                 
                });
                const response = await saveNotification(title, content,null)
                setTitle("")
                setContent("")
                toast.success("Notification Sent Succesfully")

              }
              catch (err) {
                toast.error("Error sending notification !")
              }
            }
    }  catch (err) {
      toast.error("Error sending notification !")
    }
  
  };

  useEffect(() => {
    listCustomers()
  }, []);

  const listCustomers = async () => {
    setCustomers([]);
    setClients([]);

    const response = await getCustomers();
    setClients(response.data.data);

    const customerOptions = response.data.data
    .sort((a, b) => a.firstName.localeCompare(b.firstName)) // sort A-Z by firstName
    .map((customer) => ({
      label: `${customer.firstName} ${customer.lastName} - ${customer.phoneNumber}`,
      value: customer.customerId,
    }));
  

    setCustomers(customerOptions);
  };

  return (
    <Layout>
      <ToastContainer />
      <section className="notification-page" aria-label="Send notification">
        <header className="notification-header">
          <div><p className="notification-eyebrow">CUSTOMER COMMUNICATION</p><h1>Send notification</h1><p>Reach your customers with a timely update or promotion.</p></div>
          <div className="notification-header-icon"><BellAlertIcon /></div>
        </header>
        <div className="notification-layout">
          <section className="notification-card" aria-label="Notification composer">
            <div className="notification-card-heading"><div><h2>Compose message</h2><p>Write the message customers will receive.</p></div></div>
            <div className="notification-field">
          <label htmlFor="notification">Audience</label>
          <select
            id="notification"
            value={notificationType}
            onChange={handleNotificationChange}
            className="notification-input"
          >
            <option value="Multiple Notification">All customers</option>
            <option value="Single Notification">One customer</option>
          </select>
        </div>

        {notificationType === "Single Notification" && (
          <div className="notification-field">
            <label htmlFor="customer">Customer</label>
            <select
              id="customer"
              value={selectedCustomer}
              onChange={(e) => setSelectedCustomer(e.target.value)}
              className="notification-input"
            >
              <option value="" disabled>
                Select a customer
              </option>
              {customers.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="notification-field">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="notification-input"
            placeholder="e.g. Your order is on the way"
          />
        </div>

        <div className="notification-field">
          <label htmlFor="content">Message</label>
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="notification-input notification-textarea"
            placeholder="Type your notification message…"
            rows={4}
          />
        </div>

        <div className="notification-submit-row"><span>Messages are sent immediately.</span><button onClick={handleSubmit} className="notification-send"><PaperAirplaneIcon />Send notification</button></div>
          </section>
          <aside className="notification-preview" aria-label="Notification preview">
            <div className="notification-preview-heading"><span>PREVIEW</span><BellAlertIcon /></div>
            <div className="notification-phone"><div className="notification-phone-top"><span>Now</span><BellAlertIcon /></div><div className="notification-message"><strong>{title || "Notification title"}</strong><p>{content || "Your message preview will appear here."}</p></div></div>
            <div className="notification-recipient"><span className="notification-recipient-icon">{notificationType === "Single Notification" ? <UserIcon /> : <UserGroupIcon />}</span><div><strong>{notificationType === "Single Notification" ? "One customer" : "All customers"}</strong><span>{notificationType === "Single Notification" ? (selectedCustomer ? "Selected recipient" : "Choose a recipient") : "Your entire customer list"}</span></div></div>
          </aside>
        </div>
      </section>
    </Layout>
  );
};

export default Notifications;
